import { FC } from 'react'
import { GRAY_700 } from 'constants/styling/theme'
import { Typography } from '@mui/material'
import styles from './GalleryHeader.module.sass'

interface Props {
  /** Title of the Gallery header */
  title: string
  /** Sub title of the Gallery header */
  subTitle?: string
}

/**
 * Gallery header component.
 * @example <GalleryHeader title={reference} subTitle={address} />
 */
export const GalleryHeader: FC<Props> = ({ title, subTitle }) => {

  return (
    <div className={styles.galleryHeader}>
      <Typography variant="display-md">
        {title}
      </Typography>

      <Typography variant="text-md" color={GRAY_700}>
        {subTitle}
      </Typography>
    </div>
  )
}
